/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classInfo } from "../../Store/api/classApi";
import logo from "../../assets/images/model/logo.svg";
import ArrowUp from "../../assets/images/model/errow-up.svg";
import { all as allBooks, show as singleBook } from "../../Store/api/books";
import {
  byBook as gatActivitiesByBook,
  changeAssignedDate,
} from "../../Store/api/activities";
import { setActivities, replaceActivity } from "../../Store/entities/book";
import { setChapter, setSection } from "../../Store/ui/reader";
import "react-toastify/dist/ReactToastify.css";
import LicenseIcon from "../../assets/images/licenseIcons.png";
import Frame1 from "../../assets/images/frame1.png";
import Frame2 from "../../assets/images/frame2.png";
import Frame3 from "../../assets/images/frame3.png";
import DatePicker from "react-datepicker";
import { Portal } from "react-overlays";
import funnel from "../../images/funnel.svg";
import GrayBook from "../../assets/images/bookcover.png";
import "react-datepicker/dist/react-datepicker.css";
import "react-loading-skeleton/dist/skeleton.css";
import arrow_down from "../../assets/images/angle_up_down.svg";
import { Modal, ModalBody } from "react-bootstrap";
import CustomDateInput from "../../components/CustomDateInput";
export default function PickLibSidebar({
  anchorBook = () => {},
  scrollChapter = () => {},
  scrollSection = () => {},
  draggedOver = null,
  isDraggingActivity,
  draggedActivity,
  pageState = null,

  handleShowDialoguebox = () => {},
  modalShow,
}) {
  const token = localStorage.getItem("xAuthToken");
  const emails =
    useSelector((state) => state.entities.instructors.instructors) || [];
  const { book, books } = useSelector((state) => state.entities);
  const { reader } = useSelector((state) => state.ui.reader);
  const auth = useSelector((state) => state.auth);
  const { settings } = useSelector((state) => state.settings.settings);
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const [sideBarActivity, setSideBarActivity] = useState([]);
  const [tabConent, setTabContent] = useState("content");
  const [subTab, setSubTab] = useState("all");
  const [showDatePicker, setShowDatePicker] = useState("");
  const [startDate, setStartDate] = useState("");
  const [activityDraggedOverElement, setActivityDraggedOverElement] =
    useState("");
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  /* No book Select */

  //Create Class States
  const dispatch = useDispatch();
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }

  const [modalShows, setModalShows] = useState(false);
  const handleClose = () => {
    setModalShows(false);
    // Your closing logic here...
  };
  const handleCustomClick = () => {};

  const setTabs = (e, value) => {
    setTabContent(value);
  };

  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };

  const toggleSidebarActivity = (e, value) => {
    if (sideBarActivity.includes(value)) {
      setSideBarActivity(sideBarActivity.filter((e) => e !== value));
    } else {
      setSideBarActivity([...sideBarActivity, value]);
    }
  };
  useEffect(() => {
    dispatch(
      allBooks({
        onSuccess: (res) => {
          dispatch(
            singleBook({
              id: res.data.data[0]._id,
              onSuccess: (res) => {},
            })
          );
          dispatch(
            gatActivitiesByBook({
              id:
                res.data.data[0].activitiesSet || !auth.token
                  ? res.data.data[0]._id
                  : res.data.data[0].parentBook,
              onSuccess: (res) => {},
            })
          );
        },
      })
    );
  }, [auth.token]);

  useEffect(() => {}, [books]);

  useEffect(() => {
    if (auth.token) {
      dispatch(
        classInfo({
          onSuccess: (res) => {},
        })
      );
    }

    // return () => {
    //   dispatch(resetClass())
    //   dispatch(resetClasses())
    // }
  }, []);

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");
    return <Portal container={el}> {children} </Portal>;
  };
  const customDayStyle = (date, activity) => {
    const now = new Date();
    const assignment = new Date(activity.assignedDate);
    const isActivity = book.activities.findIndex(
      (e) =>
        new Date(e.assignedDate).getDate() === date.getDate() &&
        new Date(e.assignedDate).getMonth() === date.getMonth() &&
        new Date(e.assignedDate).getFullYear() === date.getFullYear()
    );
    if (
      date.getDate() === assignment.getDate() &&
      date.getMonth() === assignment.getMonth() &&
      date.getFullYear() === assignment.getFullYear()
    ) {
      return "assigned-day assignment-day future";
    } else if (date.getDate() === 1) {
      return "first-day";
    } else if (isActivity >= 0) {
      if (
        (date.getDate() > now.getDate() &&
          date.getFullYear() === now.getFullYear() &&
          date.getMonth() === now.getMonth()) ||
        date.getFullYear() > now.getFullYear() ||
        (date.getFullYear() === now.getFullYear() &&
          now.getMonth() < date.getMonth())
      ) {
        return "assignment-day future";
      } else {
        return "assignment-day past";
      }
    } else if (
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear()
    ) {
      return "current-day";
    } else if (date.getDay() === 0) {
      return "sunday";
    } else if (
      (date.getDate() > now.getDate() &&
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth()) ||
      date.getFullYear() > now.getFullYear() ||
      (date.getFullYear() === now.getFullYear() &&
        now.getMonth() < date.getMonth())
    ) {
      return "future-day";
    } else {
      return "normal-day";
    }
  };

  const DynamicSpan = (props) => {
    const now = new Date();
    const assignementDate = new Date(props.date);
    const initialText = props.assigned
      ? new Date(props.date).toLocaleDateString("en-029", options)
      : `ASSIGN`;
    const [text, setText] = useState(initialText);
    const [isMouseTop, setIsMouseTop] = useState(false);
    const handleOver = (e) => {
      if (
        showDatePicker !== `${props.chapter}.${props.section}.${props.activity}`
      )
        setText(`${props.assigned ? initialText : "ASSIGN"}`);
      setIsMouseTop(true);
    };
    const handleLeave = (e) => {
      setText(initialText);
      setIsMouseTop(false);
    };

    const handleClick = (e) => {
      e.stopPropagation();
      if (
        showDatePicker === `${props.chapter}.${props.section}.${props.activity}`
      ) {
        setShowDatePicker("");
      } else {
        setShowDatePicker(
          `${props.chapter}.${props.section}.${props.activity}`
        );
      }
    };
    return (
      <div
        className={`${
          showDatePicker ===
          `${props.chapter}.${props.section}.${props.activity}`
            ? ""
            : "dynamic-span"
        }`}
      >
        {showDatePicker !==
          `${props.chapter}.${props.section}.${props.activity}` && (
          <div
            className="chepter"
            onMouseOver={handleOver}
            onMouseLeave={(e) => {
              handleLeave(e);
            }}
            onClick={(e) => {
              setStartDate(
                assignementDate !== ""
                  ? new Date(assignementDate).toLocaleString("en-029")
                  : new Date("1/1/1970").toLocaleString("en-029")
              );
              handleClick(e);
            }}
          >
            {(isMouseTop || showDatePicker) && text !== "ASSIGN" && (
              <div className="select-a-day">select a day</div>
            )}

            <div
              type="text"
              className="date-text"
              style={{
                textDecoration: `${text === "ASSIGN" ? "underline" : "none"}`,
                color: `${
                  text !== "ASSIGN" &&
                  (now.getDate() < assignementDate.getDate() ||
                    now.getMonth() < assignementDate.getMonth() ||
                    now.getFullYear() < assignementDate.getFullYear())
                    ? "#6700B2"
                    : "gray"
                }`,
              }}
            >
              {text}
            </div>
          </div>
        )}
      </div>
    );
  };
  const onChangeDatePickerStartDate = (e, activity) => {
    dispatch(
      changeAssignedDate({
        id: activity._id,
        body: { assignedDate: e.toISOString() },
        onSuccess: (res) => {},
        onError: (error) => {},
      })
    );
    const newAct = {
      ...activity,
      assigned: true,
      assignedDate: e ? e.toISOString() : activity.assignedDate,
    };
    const index = book.activities.findIndex((e) => e._id === activity._id);
    setStartDate(e ? e.toLocaleString("en-029") : activity.assignedDate);
    dispatch(replaceActivity({ activity: newAct, index }));
    setShowDatePicker("");
  };

  const renderNewActivities = () => {
    return (
      <div className="Contents_tabs custom_tabs_chapater">
        {" "}
        {book.activities.map((activity, actIndex) => (
          <div
            className="accordion-item activity-element"
            key={activity.chapter + "." + activity.section + "." + actIndex}
          >
            <h2 className="accordion-header activity-element">
              <div
                // className={
                //   sideBarActivity.includes(`${chapter._id}-${section._id}-${activity._id}`) ? "accordion-button active main_head fw_700" : "accordion-button collapsed main_head fw_700"
                // }
                className={`${
                  sideBarActivity.includes(
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  )
                    ? "accordion-button active main_head fw_700"
                    : "accordion-button main_head fw_700 collapsed"
                } ${
                  activity.assigned ? "assigned" : ""
                } activity-btn activity-element`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseKnowledge"
                aria-expanded={sideBarActivity.includes(
                  `${activity.chapter}-${activity.section}-${activity._id}`
                )}
                aria-controls="panelsStayOpen-collapseKnowledge"
                onClick={(e) => {
                  toggleSidebarActivity(
                    e,
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  );
                }}
              >
                <div className="chap_title activity-element">
                  <span className="eclipses">{activity.title}</span>
                  <img
                    src={arrow_down}
                    alt="arrow"
                    className="activity-element"
                  />
                </div>{" "}
                <DynamicSpan
                  activity={actIndex}
                  chapter={activity.chapter}
                  section={activity.section}
                  assigned={activity.assigned}
                  date={activity.assigned ? activity.assignedDate : ""}
                />
              </div>
            </h2>
            <div className="date-picker-wraper activity-element">
              {showDatePicker ===
              `${activity.chapter}.${activity.section}.${actIndex}` ? (
                <DatePicker
                  key={activity._id}
                  closeOnScroll={true}
                  selected={undefined}
                  open
                  renderDayContents={(day, date) => (
                    <div className={customDayStyle(date, activity)}>{day}</div>
                  )}
                  className="react-datepicker"
                  onClickOutside={(e) => {
                    if (
                      !e.target.classList.contains("react-datepicker") &&
                      !e.target.classList.contains("date-input")
                    ) {
                      setShowDatePicker("");
                    }
                  }}
                  onChange={(e) => onChangeDatePickerStartDate(e, activity)}
                  popperContainer={CalendarContainer}
                  customInput={
                    <CustomDateInput
                      changeHandler={onChangeDatePickerStartDate}
                      date={startDate}
                      activity={activity}
                    />
                  }
                />
              ) : (
                ""
              )}
            </div>
            <div
              // id="panelsStayOpen-collapseSubdisciplines"
              className={
                sideBarActivity.includes(
                  `${activity.chapter}-${activity.section}-${activity._id}`
                )
                  ? "accordion-collapse collapse event-less show"
                  : "accordion-collapse collapse event-less"
              }
              aria-labelledby="panelsStayOpen-Subdisciplines"
            >
              <div className="accordion-body event-less">
                {activity.questions.map((question, quesIndex) => (
                  <div key={quesIndex} className="event-less">
                    <p className="event-less">
                      <a className="event-less">{question.text}</a>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const dynamicChapterClass = (chapter, index) => {
    let className =
      "accordion-button main_head chapter_element chapter-btn chapter_element_left";
    className += sideBar.includes(chapter.title) ? " active" : " collapsed";
    className += reader.chapter === index ? " bg_grey fw_700" : "";
    className +=
      (draggedOver &&
        draggedOver.type === "chapter" &&
        draggedOver.index === chapter._id) ||
      activityDraggedOverElement === chapter._id
        ? " trigger"
        : "";
    className +=
      book.activities.findIndex(
        (e) => e.chapter === chapter._id && !e.section
      ) > -1
        ? " purple"
        : "";
    return className;
  };
  const dynamicSectionClass = (chapter, section, index, secIndex) => {
    let className = "section-btn section_element section_element_left";
    className +=
      (draggedOver &&
        draggedOver.type === "section" &&
        draggedOver.index === chapter._id + "." + section._id) ||
      activityDraggedOverElement === section._id
        ? " trigger"
        : "";
    className += sideBarSection.includes(`${chapter._id}-${section._id}`)
      ? " accordion-button main_head active"
      : " accordion-button main_head collapsed";
    if (
      book.activities.findIndex(
        (e) => e.section === section._id && e.paragraphs.length === 0
      ) > -1
    ) {
      className += " purple";
    }
    return className;
  };
  const miniChapText = (activities) => {
    if (activities.length > 1) return activities.length + " activities";
    if (activities.length === 1) {
      let activity = activities[0];
      if (!activity.assigned) return "unassigned";
      return new Date(activity.assignedDate).toLocaleDateString("en-029");
    }
  };
  const renderChapters = () => {
    return (
      <div
        className="tab-pane fade show active custom_tabs_chapater"
        onMouseLeave={() => {
          setActivityDraggedOverElement("");
        }}
      >
        <div className="accordion" id="accordion_active">
          {book.chapters.map((chapter, index) => {
            const chapActivities = book.activities.filter(
              (e) => e.chapter === chapter._id && !e.section
            );
            const chapActivity = chapActivities[0];
            return (
              <div key={index}>
                <div className={`accordion-item`}>
                  <h2
                    className="accordion-header"
                    // id="panelsStayOpen-Preface"
                  >
                    <div
                      // className={
                      //   sideBar.includes(chapter.title)
                      //     ? "accordion-button main_head fw_700 bg_grey active"
                      //     : "accordion-button main_head fw_700 bg_grey collapsed"
                      // }
                      onMouseEnter={() => {
                        if (isDraggingActivity) {
                          setActivityDraggedOverElement(chapter._id);
                        }
                      }}
                      onMouseUp={() => {
                        if (isDraggingActivity) {
                          const draggedActivityIndex =
                            book.activities.findIndex(
                              (e) => e._id === draggedActivity._id
                            );
                          dispatch(
                            replaceActivity({
                              activity: {
                                ...draggedActivity,
                                chapter: chapter._id,
                                section: "",
                                paragraphs: [],
                              },
                              index: draggedActivityIndex,
                            })
                          );
                        }
                        setActivityDraggedOverElement("");
                      }}
                      className={dynamicChapterClass(chapter, index)}
                      type="button"
                      aria-expanded={
                        sideBar.includes(chapter.title) ? true : false
                      }
                      aria-controls="panelsStayOpen-collapsePreface"
                      data-id={chapter._id}
                    >
                      {"    "}{" "}
                      <div
                        className="chap_title"
                        onClick={(e) => scrollChapter(chapter._id, index)}
                      >
                        <span className="eclipses">{chapter.title}</span>
                        <img
                          onClick={(e) => expendSidebar(e, chapter.title)}
                          src={arrow_down}
                          alt="arrow"
                        />
                      </div>{" "}
                    </div>
                  </h2>
                  <div className="date-picker-wraper activity-element">
                    {showDatePicker === `${chapter._id}` && (
                      <DatePicker
                        // selected={new Date(activity.assignedDate)}
                        closeOnScroll={true}
                        selected={undefined}
                        open
                        renderDayContents={(day, date) => (
                          <div className={customDayStyle(date, chapActivity)}>
                            {day}
                          </div>
                        )}
                        className="react-datepicker"
                        // popperPlacement="top-start"
                        onClickOutside={(e) => {
                          if (
                            !e.target.classList.contains("react-datepicker") &&
                            !e.target.classList.contains("date-input")
                          ) {
                            setShowDatePicker("");
                          }
                        }}
                        onChange={(e) =>
                          onChangeDatePickerStartDate(e, chapActivity)
                        }
                        popperContainer={CalendarContainer}
                        customInput={
                          <CustomDateInput
                            changeHandler={onChangeDatePickerStartDate}
                            activity={chapActivity}
                            date={startDate}
                          />
                        }
                      />
                    )}
                  </div>
                  <div
                    // id="panelsStayOpen-collapsePreface"
                    className={
                      sideBar.includes(chapter.title)
                        ? "accordion-collapse collapse show"
                        : "accordion-collapse collapse"
                    }
                    aria-labelledby="panelsStayOpen-Preface"
                  >
                    {/* <div className="accordion-body">
                    <p className="f14">{chapter.description}</p>
                  </div> */}
                    <div
                      className="accordion-body bl"
                      style={{ marginLeft: "8px" }}
                    >
                      {chapter.sections.map((section, secIndex) => {
                        const sectActivities = book.activities.filter(
                          (e) =>
                            e.section === section._id && !e.paragraphs.length
                        );
                        const sectActivity = sectActivities[0];
                        return (
                          <div key={secIndex} className="section_element">
                            <div className="accordion-item">
                              <h2
                                className="accordion-header"
                                // id="panelsStayOpen-Biological"
                              >
                                <button
                                  className={dynamicSectionClass(
                                    chapter,
                                    section,
                                    index,
                                    secIndex
                                  )}
                                  // className={
                                  //   sideBarSection.includes(
                                  //     `${chapter._id}-${section._id}`
                                  //   )
                                  //     ? "accordion-button  main_head  active"
                                  //     : "accordion-button  main_head  collapsed"
                                  // }
                                  data-id={`${chapter._id}.${section._id}`}
                                  type="button"
                                  data-bs-toggle="collapse"
                                  aria-expanded={sideBarSection.includes(
                                    `${chapter._id}-${section._id}`
                                  )}
                                  onMouseEnter={(e) => {
                                    e.stopPropagation();
                                    if (isDraggingActivity) {
                                      setActivityDraggedOverElement(
                                        section._id
                                      );
                                    }
                                  }}
                                  onMouseUp={(e) => {
                                    // e.stopPropagation();
                                    if (isDraggingActivity) {
                                      const draggedActivityIndex =
                                        book.activities.findIndex(
                                          (e) => e._id === draggedActivity._id
                                        );
                                      dispatch(
                                        replaceActivity({
                                          activity: {
                                            ...draggedActivity,
                                            chapter: chapter._id,
                                            section: section._id,
                                            paragraphs: [],
                                          },
                                          index: draggedActivityIndex,
                                        })
                                      );
                                    }
                                    setActivityDraggedOverElement("");
                                  }}
                                >
                                  <div
                                    className="chap_title"
                                    onClick={(e) =>
                                      scrollSection(secIndex, index)
                                    }
                                  >
                                    <span className="eclipses sects">
                                      {section.title}
                                    </span>
                                    <img
                                      onClick={(e) =>
                                        toggleSidebarSection(
                                          e,
                                          `${chapter._id}-${section._id}`
                                        )
                                      }
                                      src={arrow_down}
                                      alt="arrow"
                                    />
                                  </div>{" "}
                                </button>
                                <div
                                  className={
                                    sideBarSection.includes(
                                      `${chapter._id}-${section._id}`
                                    )
                                      ? "accordion-collapse collapse show"
                                      : "accordion-collapse collapse"
                                  }
                                  aria-labelledby="panelsStayOpen-Biological"
                                >
                                  <div className="accordion-body bl">
                                    {section.paragraphs.map(
                                      (paragraph, parIndex) => {
                                        const pActivities =
                                          book.activities.filter((e) =>
                                            e.paragraphs.includes(paragraph._id)
                                          );
                                        const pActivity = pActivities[0];
                                        return (
                                          <div key={parIndex}>
                                            <div className="accordion-item p-element">
                                              <h2
                                                className={`accordion-header`}
                                              >
                                                <div
                                                  className="accordion-body"
                                                  style={{ marginTop: "8px" }}
                                                >
                                                  <div>
                                                    <p className={`left-ps`}>
                                                      <a
                                                        className={`cursor eclipses ps ${
                                                          book.activities.findIndex(
                                                            (e) =>
                                                              e.paragraphs.includes(
                                                                paragraph._id
                                                              )
                                                          ) > -1 && "purple"
                                                        }`}
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          dispatch(
                                                            setChapter(index)
                                                          );
                                                          dispatch(
                                                            setSection(secIndex)
                                                          );
                                                          if (anchorBook) {
                                                            anchorBook(
                                                              chapter._id,
                                                              section._id,
                                                              paragraph._id
                                                            );
                                                          } else {
                                                            return;
                                                          }
                                                        }}
                                                      >
                                                        {paragraph.title
                                                          ? paragraph.title
                                                          : paragraph.text
                                                          ? paragraph.text
                                                          : paragraph.image &&
                                                            paragraph.image
                                                              .description
                                                          ? paragraph.image
                                                              .description
                                                          : "Paragraph " +
                                                            parIndex +
                                                            1}
                                                      </a>
                                                    </p>
                                                  </div>
                                                </div>
                                              </h2>
                                              <div className="date-picker-wraper activity-element">
                                                {showDatePicker ===
                                                  `${paragraph._id}` && (
                                                  <DatePicker
                                                    // selected={new Date(activity.assignedDate)}
                                                    closeOnScroll={true}
                                                    selected={undefined}
                                                    open
                                                    renderDayContents={(
                                                      day,
                                                      date
                                                    ) => (
                                                      <div
                                                        className={customDayStyle(
                                                          date,
                                                          pActivity
                                                        )}
                                                      >
                                                        {day}
                                                      </div>
                                                    )}
                                                    className="react-datepicker"
                                                    onClickOutside={(e) => {
                                                      if (
                                                        !e.target.classList.contains(
                                                          "react-datepicker"
                                                        ) &&
                                                        !e.target.classList.contains(
                                                          "date-input"
                                                        )
                                                      ) {
                                                        setShowDatePicker("");
                                                      }
                                                    }}
                                                    onChange={(e) =>
                                                      onChangeDatePickerStartDate(
                                                        e,
                                                        pActivity
                                                      )
                                                    }
                                                    popperContainer={
                                                      CalendarContainer
                                                    }
                                                    customInput={
                                                      <CustomDateInput
                                                        changeHandler={
                                                          onChangeDatePickerStartDate
                                                        }
                                                        activity={pActivity}
                                                        date={startDate}
                                                      />
                                                    }
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              </h2>
                              <div className="date-picker-wraper activity-element">
                                {showDatePicker === `${section._id}` && (
                                  <DatePicker
                                    // selected={new Date(activity.assignedDate)}
                                    closeOnScroll={true}
                                    selected={undefined}
                                    open
                                    renderDayContents={(day, date) => (
                                      <div
                                        className={customDayStyle(
                                          date,
                                          sectActivity
                                        )}
                                      >
                                        {day}
                                      </div>
                                    )}
                                    className="react-datepicker"
                                    onClickOutside={(e) => {
                                      if (
                                        !e.target.classList.contains(
                                          "react-datepicker"
                                        ) &&
                                        !e.target.classList.contains(
                                          "date-input"
                                        )
                                      ) {
                                        setShowDatePicker("");
                                      }
                                    }}
                                    onChange={(e) =>
                                      onChangeDatePickerStartDate(
                                        e,
                                        sectActivity
                                      )
                                    }
                                    popperContainer={CalendarContainer}
                                    customInput={
                                      <CustomDateInput
                                        changeHandler={
                                          onChangeDatePickerStartDate
                                        }
                                        activity={sectActivity}
                                        date={startDate}
                                      />
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div
        onClick={() => {
          if (!modalShow && token && settings.siteMode !== "teach") {
            handleShowDialoguebox();
          }
        }}
        className={
          settings.siteMode === "teach"
            ? "left_side_bar teach custom_nav"
            : "left_side_bar custom_nav"
        }
        style={{
          // paddingLeft: "24px",
          display: settings.bookMode ? "none" : "block",
        }}
      >
        {/* {settings.siteMode === "teach" ? ( */}
        <div
          className={`logo_wrap`}
          style={{ marginBottom: "25.02px", height: "34px" }}
        >
          <a
          //   href="https://greyled.com"
          >
            <img src={logo} alt="" />
          </a>
        </div>
        {/* ) : (
          ""
        )} */}

        <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`${
                tabConent === "content" ? "nav-link active" : "nav-link"
              } ${auth && auth.token && auth.user ? "" : "disabled"}`}
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#Contents"
              type="button"
              role="tab"
              aria-controls="Contents"
              aria-selected="true"
              onClick={(e) => {
                handleShowDialoguebox();
                setTabs(e, "content");
              }}
            >
              Contents
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={tabConent === "class" ? "nav-link active" : "nav-link"}
              id="classroom-tab"
              data-bs-toggle="tab"
              data-bs-target="#classroom"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              onClick={(e) => {
                setTabs(e, "details");
              }}
            >
              Details
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className={
              tabConent === "content"
                ? "tab-pane fade show active"
                : "tab-pane fade show"
            }
            id="Contents"
            role="tabpanel"
            aria-labelledby="Contents-tab"
          >
            <div className="Contents_tabs">
              <div className="tabs_content classroom_wrap" id="myContents">
                {subTab === "all" ? (
                  <div
                    className="tab-pane fade show active custom_tabs_chapater"
                    aria-labelledby="all-tab"
                  >
                    {renderChapters()}
                  </div>
                ) : (
                  ""
                )}
                {subTab === "activities" ? (
                  <div
                    className="tab-pane fade show active"
                    aria-labelledby="Activities-tab"
                  >
                    {renderNewActivities()}
                  </div>
                ) : (
                  ""
                )}
                {subTab === "activities-chapters" ? (
                  <div>
                    <div className="sidebar_subheading">
                      <span> CHAPTERS</span>
                      <img src={funnel} alt="" />
                    </div>
                    <hr />
                    <div className="vh-50">{renderChapters()}</div>
                    <div className="sidebar_subheading">
                      <span> ACTIVITIES</span>
                      <img src={funnel} alt="" />
                    </div>
                    <hr />
                    <div className="vh-50">{renderNewActivities()}</div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/*  {auth && auth.token && (
                <div className="btn_bottom mt-45">
                  <button
                    className="library_btn left_bottom_btn"
                    style={{
                      width: "100%",
                    }}>
                    Add a textbook block <img src={ArrowUp} alt="arrowUp" />
                  </button>
                </div>
              )} */}
            </div>
          </div>
          <div
            className={
              tabConent === "details"
                ? "tab-pane fade show active"
                : "tab-pane fade show"
            }
            id="classroom"
            role="tabpanel"
            aria-labelledby="classroom-tab"
          >
            <div className="tabs_content classroom_wrap cursor_default">
              <div>
                <h5 className="classroom_heading mt-64"> details</h5>

                {/*  {auth && auth.token && (
                  <div className="btn_bottom mt-45">
                    <button
                      className="library_btn left_bottom_btn"
                      style={{
                        width: "100%",
                      }}>
                      Add a textbook block <img src={ArrowUp} alt="arrowUp" />
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
        {auth && auth.token && (
          <div className="btn_bottom mt-45">
            <button
              className="library_btn left_bottom_btn"
              style={{
                width: "100%",
              }}
            >
              Add a textbook block <img src={ArrowUp} alt="arrowUp" />
            </button>
          </div>
        )}
      </div>

      <>
        {/* Your other content here... */}
        <Modal
          show={modalShows}
          onHide={handleClose}
          backdrop="static"
          className="modal fade custom_modal_not model_with"
          id="Not_yet"
          tabIndex="-1"
          aria-labelledby="Not_yetLabel"
          aria-hidden="true"
        >
          <div className="modal-width">
            <ModalBody>
              <button
                onClick={handleClose}
                type="button"
                className="btn_close_modal"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src="/assets/images/cross.png" alt="cross" />
              </button>
              <div className="modal-body modal_content_main_Wrap">
                <div
                  className="modal_content_box"
                  style={{ marginLeft: "0px" }}
                >
                  <h1>not yet!</h1>
                  <p>
                    Complete signup to see assignments, read the book and
                    connect with other students in your class.
                  </p>
                </div>
                <div className="btn_wrap_info" style={{ marginTop: "40px" }}>
                  {/* Customize the onClick event for this button */}
                  <button
                    type="button"
                    className="btn_black_theme"
                    onClick={handleCustomClick}
                  >
                    Take me back to signup
                    {/* Take me back to signup */}
                  </button>
                  <button type="button" className="btn_outline_dark mt_24">
                    I just want to read
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </>
    </div>
  );
}

const ContentGreyboxes = ({ noBookSelect }) => {
  return (
    <div className="class_room_box">
      <div className="class_room_img_greybox">
        <img src={GrayBook} alt="class_rom_img" className="class_rom_img" />
      </div>
      <div className="class_room_content pdl-20">
        <div className="content_top">
          {noBookSelect ? (
            <Fragment>
              {" "}
              <h6 className="text-uppercase text-grey mb-0">
                No book selected
              </h6>
              <h6 className="no-book-return">
                Return to Greyled library --{">"}
              </h6>
            </Fragment>
          ) : (
            <Fragment>
              {" "}
              <h6 className="text-uppercase text-grey mb-0">
                You're reading: <span></span>
              </h6>
              <div
                className="book_graybox_height "
                style={{ paddingBottom: "2px" }}
              >
                <img src={Frame1} alt="copyrights" />
              </div>
              <div className="book_graybox_height graybox-1">
                <img src={Frame2} alt="copyrights" />
              </div>
              <div className="book_graybox_height graybox-1">
                <img src={Frame3} alt="copyrights" />
              </div>
              <div className="book_graybox_height graybox-2">
                <img src={LicenseIcon} alt="copyrights" />
                <img
                  src={LicenseIcon}
                  style={{ marginLeft: "8px" }}
                  alt="lisence"
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
